import { useTranslate } from '@ur-solutions/react-hooks'
import { Module } from '@/modules/companies/consts'
import React from 'react'
import { InfoBox, SettingsWrapper } from '../components'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'
import { VehicleExpirationTypeSettings } from '../components/VehicleExpirationTypeSettings'
import { VehicleTableSettings } from '../components/VehicleTableSettings'

interface VehicleFleetSettingsProps {}

export const VehicleFleetSettings: React.FC<VehicleFleetSettingsProps> = () => {
  const translations = useTranslate({
    info: 'settings.info.vehicles',
  })

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox>
        <p>{translations.info}</p>
      </InfoBox>

      <ModuleResponsibleUsers module={Module.VEHICLES} />

      <VehicleExpirationTypeSettings />

      <VehicleTableSettings />
    </SettingsWrapper>
  )
}
